import React, { useContext } from "react";
import TopActionBar from "./top-action-bar";
import { RECON_DATA } from "./constants";
import { ReconContext } from "./recon-context";
const BUTTON_CONTAINER_CLASS = 'border border-greyDEDEDF bg-white rounded-[6px] pl-[16px] pr-[22px] py-[13px] w-1/2 flex cursor-pointer';

export default function ReconHeader() {
  return <div className="flex gap-10 flex-col">
    <div className="flex gap-30 w-full">
      <UploadFileButton />
      <PendingReconSection />
    </div>
    <TopActionBar />
  </div>
}

function UploadFileButton() {
  const { toggleUploadModal } = useContext(ReconContext);
  return <div id='recon-upload-section' className={BUTTON_CONTAINER_CLASS} onClick={toggleUploadModal}>
    <div className="w-[166px]"><div className="rista-sprite upload-files-recon"></div></div>
    <div className="ml-[12px] flex flex-col gap-[12px] justify-center">
      <div className="font-semibold text-[18px]">{RECON_DATA.header.uploadText}</div>
      <div className="text-[15px] text-black/80">{RECON_DATA.header.uploadTextDescription}</div>
    </div>
    <div className="w-[42px] flex items-center justify-center ml-auto"><div className="rista-sprite right-arrow-enabled"></div></div>
  </div>
}

function PendingReconSection() {
  const { reconContextData, setReportViewType } = useContext(ReconContext);
  const { reportsViewData: { pendingReports } } = reconContextData;

  // setReportViewType.bind(null, ReportsType.pending)
  return <div id='recon-pending-button' onClick={() => { }} className={BUTTON_CONTAINER_CLASS}>
    <div className="w-[166px]"><div className="rista-sprite discrepancy-reports"></div></div>
    <div className="ml-[12px] flex flex-col justify-around">
      <div className="w-fit text-center bg-[#FFD3D3] text-[#B74141] text-[11px] px-[8px] py-2 font-semibold rounded-t-[6px] rounded-b-[6px]">{pendingReports.length} REPORTS</div>
      <div className="font-semibold text-[18px]">{RECON_DATA.header.discrepancyText}</div>
      <div className="text-[15px] text-black/80">{RECON_DATA.header.pendingTextDescription}</div>
    </div>
    <div className="w-[41px] flex items-center ml-auto"><div className={`rista-sprite ml-auto ${pendingReports.length ? 'right-arrow-enabled' : "right-arrow-disabled"} my-auto `}></div></div>
  </div>
}